import { render, staticRenderFns } from "./page-grid-view-items.vue?vue&type=template&id=5b28cc53&scoped=true"
import script from "./page-grid-view-items.vue?vue&type=script&lang=js"
export * from "./page-grid-view-items.vue?vue&type=script&lang=js"
import style0 from "./page-grid-view-items.vue?vue&type=style&index=0&id=5b28cc53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28cc53",
  null
  
)

export default component.exports